/* @flow */

import * as React from 'react';
import './bulleted-list.css';

type Bullet = React.Node | string;

type Props = {|
    bullets: Bullet[],
    size: 'normal' | 'big' | 'small',
|};

export class BulletedList extends React.PureComponent<Props> {
    static defaultProps = {
        size: 'normal',
    };

    render() {
        return (
            <ul styleName={`bulleted-list--${this.props.size}`}>
                {this.props.bullets.map((bullet, index) => {
                    return (
                        // eslint-disable-next-line react/no-array-index-key
                        <li styleName={`list-item--${this.props.size}`} key={index}>
                            {bullet}
                        </li>
                    );
                })}
            </ul>
        );
    }
}
